export const makeMyLastWordBold = (string) => {
  const makeLastWordBold = string.replace(
    string.split(" ").pop(),
    `${"<span class='makemebold'>" + string.split(" ").pop() + "</span>"}`
  );

  return makeLastWordBold;
};
